import { createIconComponent } from '../../factory/create-icon-component';
export const ReplyIcon = createIconComponent(
  'ReplyIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 11L7 6M2 11H15.6C17.8402 11 18.9603 11 19.816 11.436C20.5686 11.8195 21.1805 12.4314 21.564 13.184C22 14.0397 22 15.1598 22 17.4V17.5V18M2 11L7 16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
